import {register} from "../../index";
import {echarts, echartsList} from "./echarts";

export function registerEcharts(_echarts) {
  echartsList.echarts = _echarts
  register({
    echarts
  })
}